"use client";

import { c as _c } from "react/compiler-runtime";
import { v4 as uuidv4 } from "uuid";
import { useCallback, useMemo, useState } from "react";
export interface EmailAttachmentFile {
  id: string;
  file: File;
}
interface UseEmailAttachmentsOptions {
  maxFiles?: number;
  maxFileSizeBytes?: number;
}
const DEFAULT_MAX_FILES = 10;
const DEFAULT_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024; // 25MB

export function useEmailAttachments(options) {
  const $ = _c(12);
  const maxFiles = options?.maxFiles ?? DEFAULT_MAX_FILES;
  const maxFileSizeBytes = options?.maxFileSizeBytes ?? DEFAULT_MAX_FILE_SIZE_BYTES;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [attachments, setAttachments] = useState(t0);
  let t1;
  if ($[1] !== maxFileSizeBytes || $[2] !== maxFiles) {
    t1 = files => {
      const errors = [];
      const sizeValidFiles = [];
      for (const file of files) {
        if (file.size > maxFileSizeBytes) {
          const maxMB = Math.round(maxFileSizeBytes / 1048576);
          errors.push(`${file.name} exceeds ${maxMB}MB limit`);
          continue;
        }
        sizeValidFiles.push({
          id: uuidv4(),
          file
        });
      }
      let added = 0;
      if (sizeValidFiles.length > 0) {
        setAttachments(prev => {
          const available = maxFiles - prev.length;
          const toAdd = sizeValidFiles.slice(0, Math.max(0, available));
          added = toAdd.length;
          return [...prev, ...toAdd];
        });
        if (added < sizeValidFiles.length) {
          errors.push(`Maximum ${maxFiles} files allowed`);
        }
      }
      return {
        added,
        errors
      };
    };
    $[1] = maxFileSizeBytes;
    $[2] = maxFiles;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const addFiles = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setAttachments(prev_0 => prev_0.filter(a => a.id !== id));
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const removeFile = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAttachments([]);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const clearAll = t3;
  let t4;
  if ($[6] !== attachments) {
    t4 = attachments.reduce(_temp, 0);
    $[6] = attachments;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const totalSize = t4;
  let t5;
  if ($[8] !== addFiles || $[9] !== attachments || $[10] !== totalSize) {
    t5 = {
      attachments,
      addFiles,
      removeFile,
      clearAll,
      totalSize,
      fileCount: attachments.length
    };
    $[8] = addFiles;
    $[9] = attachments;
    $[10] = totalSize;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(sum, a_0) {
  return sum + a_0.file.size;
}